/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { LiveManagementExportZipResponse } from './LiveManagementExportZipResponse';

export type LiveManagementExportZipResponseApiRespoonse = {
    data?: LiveManagementExportZipResponse;
    status?: LiveManagementExportZipResponseApiRespoonse.status;
    message?: string;
    errors?: Record<string, Array<string>>;
};

export namespace LiveManagementExportZipResponseApiRespoonse {

    export enum status {
        SUCCESS = 'success',
        ERROR = 'error',
    }


}

